/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CitiesPageQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CitiesPageQuery = {
  __typename?: 'Query';
  peopleCityTopLevelPage?: {
    __typename?: 'PeopleCitiesTopLevelPage';
    cityTopLevelPages?: Array<{
      __typename?: 'PeopleCityTopLevelPage';
      cityName?: string | null;
      url?: string | null;
      exampleNames?: Array<{
        __typename?: 'PeopleUserBagItem';
        name?: string | null;
        url?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export const CitiesPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CitiesPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'peopleCityTopLevelPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cityTopLevelPages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cityName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exampleNames' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CitiesPageQuery, CitiesPageQueryVariables>;
